import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import { VERIFY_EMAIL, VERIFY_EMAIL_V2 } from './constants';

export function postVerifyEmail(query) {
  if (hasFeature('enable-cmp-phase1_1-hermes-registration')) {
    return postVerifyEmailV2(query).then(resp => resp.data);
  }
  return axios
    .post(
      VERIFY_EMAIL,
      { access_token: query.access_token },
      { withCredentials: true }
    )
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

export function postVerifyEmailV2(query) {
  return axios
    .post(
      VERIFY_EMAIL_V2,
      { access_token: query.access_token },
      { withCredentials: true }
    )
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}
